import { Container, theme } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import type PlanningVersion from 'modules/time_planning/store/models/PlanningVersion'

import Content from './Content'
import Navigator from './Navigator'

export interface Props {
  planningVersion: PlanningVersion
  employeeId: number
  canEditPlanningVersions: boolean
  canAssignEmployees: boolean
  canManageCompanySchedules: boolean
  canEditShifts: boolean
  canEditContracts: boolean
}

const IdReal = observer(
  ({
    planningVersion,
    employeeId,
    canEditPlanningVersions,
    canAssignEmployees,
    canManageCompanySchedules,
    canEditShifts,
    canEditContracts,
  }: Props) => {
    return (
      <>
        <div
          style={{
            marginBottom: theme.dimensions.bodyPadding,
          }}
        >
          <Navigator
            employeeId={employeeId}
            canEditPlanningVersions={canEditPlanningVersions}
            planningVersion={planningVersion}
          />
        </div>
        <Container fullWidth>
          <Content
            employeeId={employeeId}
            planningVersion={planningVersion}
            canEditPlanningVersions={canEditPlanningVersions}
            canAssignEmployees={canAssignEmployees}
            canManageCompanySchedules={canManageCompanySchedules}
            canEditShifts={canEditShifts}
            canEditContracts={canEditContracts}
          />
        </Container>
      </>
    )
  }
)

const Id = (props: Props) => <IdReal {...props} />

export default Id
